import React from 'react';
import PropTypes from 'prop-types';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import AddPrinterForm from './AddPrinterForm';
import PrinterChip from './PrinterChip';
import style from './IdCardPrinterBoard.module.sass';

const InventoryColumn = ({
  printers, busyIds, onAddPrinter, onRetire,
}) => (
  <div className={style.column}>
    <div className={style.columnHeader}>
      Inventory
      <span className={style.columnCount}>{printers.length}</span>
    </div>
    <p className={style.columnHint}>Drag a printer onto a school to pair them.</p>

    <AddPrinterForm onAddPrinter={onAddPrinter} disabled={busyIds.includes('add-printer')} />

    <Droppable droppableId="inventory" type="printer">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className={`${style.columnBody} ${snapshot.isDraggingOver ? style.dragOver : ''}`}
        >
          {printers.length === 0 && <div className={style.emptyState}>No printers in inventory.</div>}

          {printers.map((printer, index) => (
            <Draggable key={printer.id} draggableId={`printer-${printer.id}`} index={index}>
              {(dragProvided, dragSnapshot) => (
                <div
                  ref={dragProvided.innerRef}
                  {...dragProvided.draggableProps}
                  {...dragProvided.dragHandleProps}
                >
                  <div
                    className={`
                      ${style.card} ${style.cardBarBlue}
                      ${dragSnapshot.isDragging ? style.cardDragging : ''}
                    `}
                  >
                    <PrinterChip
                      printer={printer}
                      disabled={busyIds.includes(`printer-${printer.id}`)}
                      onRetire={onRetire}
                    />
                  </div>
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </div>
);

InventoryColumn.propTypes = {
  printers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
  busyIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAddPrinter: PropTypes.func.isRequired,
  onRetire: PropTypes.func.isRequired,
};

export default InventoryColumn;
